import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { AppSettingDataService } from './appsetting-data.service';
import swal from 'sweetalert2';
import { SessionTimer } from '../models/session-timer';
import { fromEvent, merge, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class TimeOutSessionService {

  isIdling: boolean;
  isReset: boolean;
  hasEvent: boolean;
  defaultPageTimeOutMinutes: number;
  timeOutWarningSeconds: number;
  minutesToReset: number;
  iglingMinutes: number;
  displayText: string = "Closing in #sec seconds.";
  sessionTimer: SessionTimer;
  timerHandler: NodeJS.Timer;
  subscribe: Subscription;

  constructor(
    private _authenticationService: AuthenticationService,
    private _appSettingDataService: AppSettingDataService
  )
  {
  }

  private mouseEvents() {
    const mousemove = fromEvent(document, 'mousemove');
    const mousedown = fromEvent(document, 'mousedown');
    const keypress = fromEvent(document, 'keypress');
    const scroll = fromEvent(document, 'scroll');

    this.subscribe = merge(mousemove, mousedown, keypress, scroll).subscribe(e => {
      e.stopPropagation();
      if (this.isIdling) {
        this.hasEvent = false;
      }
      else {
        this.hasEvent = true;
        this.iglingMinutes = this.defaultPageTimeOutMinutes;
      }
    });

    if ((this.minutesToReset == 0) && this.hasEvent && !this.isIdling) {
      this.isReset = true;
      this.subscribe.unsubscribe();
    }
  }

  public async startSessionTimer(): Promise<void> {

    this.timerHandler = setInterval((): void => {
      this.iglingMinutes--;
      this.minutesToReset--;

      if ((this.minutesToReset == 0) && !this.isIdling) {
        this.isReset = true;
        clearInterval(this.timerHandler);
        this.runSessionTimeOut();
      }
      else if ((this.iglingMinutes == this.timeOutWarningSeconds) && !this.hasEvent)
      {
        this.isIdling = true;
        this.hasEvent = false;
        this.subscribe.unsubscribe();

        swal.fire({
          title: 'Session about to time out.<br>Do you want to continue?',
          text: this.displayText.replace(/#sec/, this.iglingMinutes.toString()),
          icon: 'warning',
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Continue',
          cancelButtonText: 'No, Sign Out!',
        }).then(async (result) => {
          if (result.value) {
            this.isReset = true;
            await this.runSessionTimeOut();
          } else {
            this._authenticationService.logout();
          }
        });
      }
      if (this.iglingMinutes < this.timeOutWarningSeconds)
      {
        this.isIdling = true;
        if (this.iglingMinutes > 0 || this.iglingMinutes == 0) {
          document.getElementById('swal2-html-container').innerHTML = this.displayText.replace(/#sec/, this.iglingMinutes.toString());
          if (this.iglingMinutes == 0) {
            this._authenticationService.logout();
          }
        }
        else {
          this._authenticationService.logout();
        }
      }
      this.hasEvent = false;
    }, 1000);
  }

  async runSessionTimeOut() {

    this.mouseEvents();
    let appSession: SessionTimer;
    if (this.isReset) {
      appSession = await this._appSettingDataService.ResetSessionTimer();
    }
    else {
      appSession = await this._appSettingDataService.GetSessionTimer('');
    }

    this.iglingMinutes = appSession.sessionTimeoutMinutes;
    this.minutesToReset = appSession.sessionTimeoutMinutes;
    this.timeOutWarningSeconds = appSession.timeOutWarningSeconds;
    this.defaultPageTimeOutMinutes = appSession.sessionTimeoutMinutes;

    this.hasEvent = false;
    this.isIdling = false;
    this.isReset = false;

    clearInterval(this.timerHandler);
    this.startSessionTimer();
  }
}
